import './assets/base.css'
import './assets/main.scss'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import PartnerPlugin from './plugins/partner'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faClock,
  faBatteryQuarter,
  faCheckCircle,
  faMapLocationDot,
  faRectangleXmark,
  faBars,
  faPlug,
  faCircleCheck,
  faMoneyBill,
  faAngleDown,
  faAngleUp,
  faXmark,
  faArrowRightToBracket,
  faArrowUpFromBracket,
  faClockRotateLeft,
  faDollarSign,
  faCopy,
  faCreditCard,
  faTrash,
  faCheck,
  faTriangleExclamation,
  faChevronRight,
  faHouse,
  faPowerOff,
  faCircleQuestion,
  faCalculator
} from '@fortawesome/free-solid-svg-icons'
import { faStar } from '@fortawesome/free-regular-svg-icons'
import { faFacebook, faGoogle, faWhatsapp, faCcMastercard, faPix, faUsb } from '@fortawesome/free-brands-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import FBSignInButton from 'vue-facebook-signin-button'
import VueTheMask from 'vue-the-mask'
import { createBootstrap } from 'bootstrap-vue-next'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import { HFaceBookLogin } from '@healerlab/vue3-facebook-login'
import VueScrollTo from 'vue-scrollto'
import vue3GoogleLogin from 'vue3-google-login'
import OneSignalVuePlugin from '@onesignal/onesignal-vue3'
import { formatToBrazilianReal, convertMinutesToHours } from '@/utils/format'
import { sessionRecorder, UserEvent, SESSION_EVENTS } from './services/sessionRecorder'
import { experimentInstance } from '@/utils/experiments'
import { vueErrorHandler, globalErrorHandler, captureException, registerVueApp } from './errors'
import { registerVueApp as registerEnhancedErrorApp } from '@/services/enhancedErrorHandler'

const app = createApp(App)

app.use(createBootstrap())
app.use(i18n)
app.use(router)
app.use(FBSignInButton)
app.use(VueTheMask)
app.use(VueScrollTo)
app.use(PartnerPlugin)

app.use(OneSignalVuePlugin, {
  appId: import.meta.env.VITE_ONE_SIGNAL_APP_ID,
  allowLocalhostAsSecureOrigin: true,
  requiresUserPrivacyConsent: true
})

library.add(
  fas,
  faCheckCircle,
  faClock,
  faBatteryQuarter,
  faFacebook,
  faGoogle,
  faWhatsapp,
  faMapLocationDot,
  faRectangleXmark,
  faBars,
  faUsb,
  faCircleCheck,
  faCcMastercard,
  faMoneyBill,
  faAngleDown,
  faAngleUp,
  faPlug,
  faXmark,
  faArrowRightToBracket,
  faArrowUpFromBracket,
  faClockRotateLeft,
  faDollarSign,
  faStar,
  faPix,
  faCopy,
  faCreditCard,
  faTrash,
  faCheck,
  faTriangleExclamation,
  faChevronRight,
  faHouse,
  faPowerOff,
  faCircleQuestion,
  faCalculator
)

if (import.meta.env.VITE_GOOGLE_CLIENT_ID) {
  app.use(vue3GoogleLogin, {
    clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID
  })
}

;(async () => {
  try {
    const sessionId = sessionStorage.getItem('session_id')
    sessionRecorder.startSession()
    if (!sessionId) {
      let extraData = { url: window.location.href }
      const qrMatch = window.location.pathname.match(/\/qr\/([^/]+)/)
      if (qrMatch) {
        extraData.token = qrMatch[1]
      }
      sessionRecorder.addUserEvent(new UserEvent(SESSION_EVENTS.START_SESSION, null, extraData))
    } else {
      sessionRecorder.addUserEvent(new UserEvent(SESSION_EVENTS.RESTART_SESSION, null, null))
    }
    await sessionRecorder.startRecording()
    registerVueApp(app)
    registerEnhancedErrorApp(app)
    app.config.errorHandler = vueErrorHandler
    window.onerror = globalErrorHandler
    await experimentInstance.fetch(sessionRecorder.sessionId)
  } catch (error) {
    app.config.errorHandler = vueErrorHandler
    window.onerror = globalErrorHandler
    console.error('Erro:', error)
    captureException(error)
  }
  app.component('FontAwesomeIcon', FontAwesomeIcon)
  app.component('HFaceBookLogin', HFaceBookLogin)
  app.config.globalProperties.formatToBrazilianReal = formatToBrazilianReal
  app.config.globalProperties.convertMinutesToHours = convertMinutesToHours
  app.mount('#app')
})()
